export const NAME = 'customerDiscounts';
